import {createActions} from 'redux-actions';

export default createActions({
    SET_PARLOUR: undefined,
    SET_VISIT_FACILITY: undefined,
    SET_DATE_VISIT: undefined,
    SET_VISIT: undefined,
    SET_DISCOUNT_ID: undefined,
    SET_TOTAL: undefined
});